import { t, useLang, type StringTable } from '@/lib/i18n';
import { Logo } from './logo';

const STRINGS = {
  'footer.copyright': { en: '© 2026 Jam-e Jam', fa: '© ۱۴۰۵ جامِ جم' },
  'footer.privacy': { en: 'Privacy', fa: 'حریمِ خصوصی' },
  'footer.terms': { en: 'Terms', fa: 'شرایط' },
  'footer.security': { en: 'Security', fa: 'امنیت' },
  'footer.aria': { en: 'Footer', fa: 'پاورقی' },
} satisfies StringTable<string>;

export function Footer() {
  const lang = useLang();

  return (
    <footer className="border-t border-[var(--color-border)] bg-[var(--color-canvas)]">
      <div className="mx-auto flex max-w-[88rem] flex-col gap-6 px-6 py-10 text-sm md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-3">
          <Logo size={32} ring className="text-[var(--color-ink-secondary)]" />
          <div className="flex flex-col gap-1">
            <span className="text-[var(--color-ink-secondary)]">
              {t(STRINGS, 'footer.copyright', lang)}
            </span>
            <span className="font-mono text-xxs uppercase tracking-wider text-[var(--color-ink-muted)]">
              Jam-e Jam · جامِ جم
            </span>
          </div>
        </div>

        <nav
          aria-label={t(STRINGS, 'footer.aria', lang)}
          className="flex items-center gap-6 text-[var(--color-ink-secondary)]"
        >
          <a href="#" className="hover:text-[var(--color-ink)]">
            {t(STRINGS, 'footer.privacy', lang)}
          </a>
          <a href="#" className="hover:text-[var(--color-ink)]">
            {t(STRINGS, 'footer.terms', lang)}
          </a>
          <a href="#" className="hover:text-[var(--color-ink)]">
            {t(STRINGS, 'footer.security', lang)}
          </a>
        </nav>
      </div>
    </footer>
  );
}
